//vault接口

const gateway = process.env.VUE_APP_GATEWAY
// const worldapi = process.env.VUE_APP_WORLDURL
const worldapi = gateway + '/card' //process.env.VUE_APP_WORLDURL
const ocrApi = "http://ocr.cardhobby.cn"////////////////////////////
const cmsApi = gateway + '/cms'//process.env.VUE_APP_CMS
const valutapi = gateway + '/vault' //process.env.VUE_APP_VAULTAPI


let apiEndpoints = {

    // 'GetSeller': ocrApi + "/Seller/GetSeller",//获取用户信息
    // 'GetWalletInfo': ocrApi + '/Wallet/GetWalletInfo',//[钱包]获取钱包信息
    // 'GetAreasList': cmsApi + "/api/City/GetAllAreas",//获取省市区

    // 'GetMyAddress': worldapi + '/Address/MyAddress',//获取我的地址列表 memberid pagesize pageindex token
    // 'getAddressList': '/order/GetMemberAddressByid',//GET 获取收货地址

    //"GetNewCommodityByCodeScor":worldapi + "/NewCommodity/GetNewCommodityByCodeScore",//根据验货报告Code获取卡的评分信息

    /* 本地接口 公用接口 */
    // 'SendRequest': '/Request/SendRequest',//本地接口 公用接口

    /* Vault统计 */
    'GetVaultStatistics': valutapi + '/api/CardCommodity/Statistics',//Vault统计全部 GET
    'GetVaultNewStatistics': valutapi + '/api/CardCommodity/NewStatistics',//Vault统计分仓和全部 GET

    /* 入库管理 */
    'GetAllValutByPage': valutapi + '/api/Valut/GetAllValutByPage',//获取仓库列表 GET
    'GetByPageForApi': valutapi + "/api/StorageOrder/GetByPageForApi",//存储订单分页查询StorageEdit POST
    'GetVaultDetail': valutapi + '/api/StorageOrder/GetById',//寄存订单详情[POST]
    'GetStorageOrderByCardOrderId': valutapi + '/api/StorageOrder/GetStorageOrderByCardOrderId',//根据卡淘订单id 获取寄存订单id
    'StorageCreate': valutapi + '/api/StorageOrder/Create',//创建寄存订单 POST
    'StorageEdit': valutapi + '/api/StorageOrder/Edit',//编辑寄存订单 POST
    'EditReturnInfo': valutapi + '/api/StorageOrder/EditReturnInfo',//退回地址编辑 POST
    'StorageRemove': valutapi + '/api/StorageOrder/Remove',//删除寄存订单 POST
    'ShipOrder': valutapi + '/api/StorageOrder/ShipOrder',//订单发货 POST

    /* 委托代卖 */
    'GetSellerUserByPage': valutapi + '/api/Seller/GetSellerUserByPage',//获取商户列表 POST
    'GetSellingList': valutapi + '/api/CardCommodity/GetSellingList',//代卖筛选列表 GET
    'GetSellerWhiteByPage': valutapi + '/api/Seller/GetSellerWhiteByPage',//获取商户白名单列表 POST
    'SaveSellerApply': valutapi + '/api/Seller/SaveSellerApply',//卡主卡片申请代卖 POST

    'GetStartBidRatio': valutapi + '/api/Valut/GetStartBidRatio',//获取起拍价比例 GET


      /* 已售出 */
    'SearchVaultSellCommodity': worldapi + '/ValutApi/SearchVaultSellCommodity',//我的出售 / 订单的待支付列表 GET

    /* valut仓库 */
    'GetCommodityByMemberId': valutapi + '/api/CardCommodity/GetCommodityByMemberId', //查询某个人所持有的卡片（在库）
    'GetCardCommodityByPage': valutapi + '/api/Seller/GetCardCommodityByPage', //查询某个人所持有的卡片（获取代卖 用户卡片）post
    'GetCommodityById': valutapi + '/api/CardCommodity/GetCommodityById', //获取卡片详情
    'SearchCommodities': worldapi + '/ValutApi/SearchCommodities', //获取我的卡片列表(上架中)
    'ReleaseCommodity': valutapi + '/api/CardCommodity/ReleaseCommodityForApp', //上架卡片 post
    'PickupApplyAdd': valutapi + '/api/PickupApply/add',//提货申请 POST
    'GetStoreListByPageApp': cmsApi + '/api/Store/GetStoreListByPageApp', //获取店铺列表 post
    'GetPickupApplyByPage': valutapi + '/api/PickupApply/GetInfosByPage',//提货申请查询 POST
    'GetPickupApplyById': valutapi + '/api/PickupApply/GetInfoById',// 提货申请详情 POST
    'GetExpressSubscribeInfo': valutapi + '/api/ExpressSubscribe/GetExpressSubscribeInfo',//提货申请查询物流 post

    /* vault卖家 */
    'UpdateApplyStatus': valutapi + '/api/Seller/UpdateApplyStatus', //代卖-修改代卖卡状态 post
}
export default apiEndpoints


// WEBPACK FOOTER //
// ./src/api/api/vault.js